import { useMerchantCabinetConfig } from '../config/ConfigProvider';
import { shouldEnableSentry } from '../utils/sentry';

export function useEnableSentry(): boolean {
  const { environment } = useMerchantCabinetConfig();
  return shouldEnableSentry(environment);
}

